import { Component, OnInit } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';
import { Client } from 'src/app/shared/models/clients/client';
import { Opponent } from 'src/app/shared/models/data/opponent';
import { ExpenseTypeEnum, TimesheetEntry, TimesheetExpense } from 'src/app/shared/models/timesheet/timesheetEntry';
import { User, UserRole } from 'src/app/shared/models/users/user';
import * as converter from 'number-to-words';
@Component({
  selector: 'app-print-timesheet',
  templateUrl: './print-timesheet.component.html',
  styleUrls: ['./print-timesheet.component.scss']
})
export class PrintTimesheetComponent implements OnInit {

  entries: TimesheetEntry[] = [];
  expenses: TimesheetExpense[] = [];
  clients: Client[];
  opponents: Opponent[];
  fileNum: string;
  user: User;
  userRole = UserRole;
  today = Date.now();
  expensesGroups: { disbursements: TimesheetExpense[], thirdPartyFees: TimesheetExpense[], thirdPartyDisbursements: TimesheetExpense[] };
  feesSubtotal: number = 0;
  VAT = 0;
  totalDisbursements: number = 0;
  totalThirdPartyFees: number = 0;
  totalThirdPartyDisbursements: number = 0;
  totalPayable: number = 0;
  totalPayableToWords: string;
  constructor(
    private printService: PrintService,
  ) {
    this.entries = this.printService.data.timesheets;
    this.expenses = this.printService.data.expenses;
    this.clients = this.printService.data.fileInfo.clients;
    this.opponents = this.printService.data.fileInfo.opponents;
    this.fileNum = this.printService.data.fileInfo.fileNum;
    this.feesSubtotal = this.entries.map(v => +v.amount).reduce((a, b) => a + b, 0) || 0;
    this.setExpensesGroups();
  }

  ngOnInit(): void {
    this.printService.onDataReady('Timesheet');
    this.VAT = Math.round((this.feesSubtotal)) / 100 || 0;
  }

  isDataEntry() {
    return this.user && (this.user.role === UserRole.ADMIN || this.user.role === UserRole.DATA_ENTRY)
  }

  setExpensesGroups() {
    let expensesGroups = { disbursements: [], thirdPartyFees: [], thirdPartyDisbursements: [] };
    this.expenses.forEach((val) => {
      if (val.expenseType == ExpenseTypeEnum['DISBURSEMENTS']) {
        expensesGroups.disbursements.push(val);
        this.totalDisbursements += val.amount;
      } else if (val.expenseType == ExpenseTypeEnum['THIRD PARTY FEES']) {
        expensesGroups.thirdPartyFees.push(val);
        this.totalThirdPartyFees += val.amount;
      } else if (val.expenseType == ExpenseTypeEnum['THIRD PARTY DISBURSEMENTS']) {
        expensesGroups.thirdPartyDisbursements.push(val);
        this.totalThirdPartyDisbursements += val.amount;
      }
    })
    this.totalPayable = this.feesSubtotal + (this.feesSubtotal * .1) + this.totalDisbursements + this.totalThirdPartyFees + this.totalThirdPartyDisbursements || 0;
    this.totalPayableToWords = converter.toWords(this.totalPayable || 0);

    this.expensesGroups = expensesGroups;
  }

}
